/**
 * KAN-507 — when is a video upload actually finished?
 *
 * GlobalUploadStatusService's fallback poll completed the upload as soon as the
 * row carried a `bunnyVideoId` and was not explicitly 'failed'. The row carries
 * that id from the instant the upload starts, so the progress UI declared
 * success while the encode had barely begun — and the instructor was handed a
 * video that could not play.
 *
 * An upload is settled only when the video reached a terminal state: the server
 * CDN-verified it as ready, or the encode failed (so the UI stops waiting).
 */

export interface VideoLike {
  id?: unknown;
  status?: string | null;
  bunnyVideoId?: unknown;
}

export function isVideoUploadSettled(video: VideoLike | null | undefined): boolean {
  const status = typeof video?.status === 'string' ? video.status.toLowerCase().trim() : '';
  return status === 'ready' || status === 'failed' || status === 'unavailable';
}
